import axios from "axios";
import api from "@/utils/api";
import { API_ENDPOINTS } from "@/constants/api";
import { AromaCategory, ReviewData, Aroma } from "@/types";
import logger from "@/utils/logger";

export const createReview = async (reviewData: ReviewData) => {
    const formData = new FormData();
    const reviewBlob = new Blob([JSON.stringify(reviewData)], { type: "application/json" });
    formData.append("review", reviewBlob);

    // 이미지 파일 추가
    reviewData.images.forEach((image, index) => {
        formData.append("images", image); // 'images' 키로 파일 추가
    });

    try {
        const response = await api.post("/api/v1/my-reviews", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            logger.error("Error creating review:", error.response?.data);
        }
        throw error;
    }
};

export const fetchAromaTags = async (): Promise<AromaCategory[]> => {
    try {
        const response = await api.get<AromaCategory[]>(API_ENDPOINTS.AROMAS);
        return response.data;
    } catch (error) {
        logger.error("Failed to fetch aroma tags:", error);
        throw error;
    }
};

// 상품 상세 정보 조회 API
export const fetchAlcoholDetail = async (altKey: string) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.ALCOHOLS}/${altKey}`);
        return response.data;
    } catch (error) {
        logger.error("Failed to fetch alcohol detail:", error);
        throw error;
    }
};

interface ReviewImageInfo {
    altKey: string;
    imageUrl: string;
    createdAt: string;
}

interface Product {
    altKey: string;
    breweryAltKey: string;
    name: string;
    type: string;
    abv: number | null;
}

export interface Review {
    altKey: string;
    userAltKey: string;
    product: Product;
    content: string;
    rating: number;
    reviewImageInfoList: ReviewImageInfo[];
    createdAt: string;
}

interface ReviewResponse {
    success: boolean;
    message: string | null;
    data: Review[];
    errorCode: string | null;
}

/**
 * 최근 리뷰 10개를 가져오는 API
 */
export const fetchRecentReviews = async (): Promise<Review[]> => {
    try {
        const response = await api.get<ReviewResponse>("/api/v1/reviews/top10");
        if (!response.data.success) {
            throw new Error(response.data.message || "리뷰를 불러오는데 실패했습니다.");
        }
        return response.data.data;
    } catch (error) {
        logger.error("리뷰 데이터를 불러오는데 실패했습니다:", error);
        throw error;
    }
};

export default createReview;
